import { API_ENDPOINTS, api } from '../apis/constants';
import { Branch } from '../types/branch';
import { cacheService } from './cache.service';

interface GetBranchesOptions {
    forceFresh?: boolean;
    cacheTTL?: number;
}

class BranchService {
    private CACHE_KEY = 'branches_data';

    async getPublicBranches(options: GetBranchesOptions = {}): Promise<Branch[]> {
        return cacheService.get<Branch[]>(
            this.CACHE_KEY,
            async () => {
                try {
                    const response = await api.get<Branch[]>(API_ENDPOINTS.BRANCHES.PUBLIC);
                    return response.data;
                } catch (error) {
                    console.error('Error fetching branches:', error);
                    throw error;
                }
            },
            {
                forceFresh: options.forceFresh,
                ttl: options.cacheTTL || 300 // Cache for 5 minutes by default
            }
        );
    }
}

export const branchService = new BranchService(); 